import { render, staticRenderFns } from "./ItemAsiento.vue?vue&type=template&id=0b476ece&"
import script from "./ItemAsiento.vue?vue&type=script&lang=js&"
export * from "./ItemAsiento.vue?vue&type=script&lang=js&"
import style0 from "./ItemAsiento.vue?vue&type=style&index=0&id=0b476ece&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports